import React from "react";
import { Zap, Moon, Compass, RefreshCw, CircleDot } from "lucide-react";

/**
 * Maps a compass result to its accent color and Lucide icon.
 * Colors match the Phase-1 palette:
 *   act    → gold      #F4C95D
 *   rest   → light blue#93C5FD
 *   stay   → mint      #A7F3D0
 *   change → warm orang#FDBA74
 *   pause  → soft purpl#C4B5FD
 */
export const RESULT_META = {
  act: { color: "#F4C95D", Icon: Zap },
  rest: { color: "#93C5FD", Icon: Moon },
  stay: { color: "#A7F3D0", Icon: Compass },
  change: { color: "#FDBA74", Icon: RefreshCw },
  pause: { color: "#C4B5FD", Icon: CircleDot },
};

/**
 * ResultBadge — a large glowing icon in the result's accent color.
 * Used on /result and on the "already done" summary on /today.
 */
export function ResultBadge({ result, size = 88 }) {
  const meta = RESULT_META[result] || RESULT_META.stay;
  const { color, Icon } = meta;
  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
      aria-hidden="true"
      data-testid={`result-badge-${result}`}
    >
      <div
        className="absolute inset-0 rounded-full"
        style={{
          background: `radial-gradient(circle, ${color}45 0%, ${color}00 65%)`,
          filter: "blur(6px)",
        }}
      />
      <div
        className="relative flex items-center justify-center rounded-full"
        style={{
          width: size * 0.72,
          height: size * 0.72,
          background: `linear-gradient(135deg, ${color}22, ${color}0A)`,
          border: `1px solid ${color}55`,
        }}
      >
        <Icon
          size={Math.round(size * 0.36)}
          strokeWidth={1.6}
          style={{ color }}
        />
      </div>
    </div>
  );
}
